import { Form } from "antd"
import { Group, Legend } from "components/common"
import {
  getReviewFormItemConfig,
  getSectionTitle,
  isDependencySatisfied,
  NEXT_PROPOSED_TASK_KEY,
  NO_DEP_WATCH,
} from "../utils"
import { useGetNewTasksQuery } from "features/leads/api"
import { ReviewFormField } from "./ReviewFormField"

function useDependentFieldVisible(field, form) {
  const parentKey = field?.dependent?.field
  const watched = Form.useWatch(parentKey ?? NO_DEP_WATCH, form)
  const parentValue = parentKey ? watched : undefined
  return !parentKey || isDependencySatisfied(parentValue, field?.dependent)
}

function ReviewFormFieldRow({ field, form, taskOptions, taskOptionsLoading, disabled }) {
  const visible = useDependentFieldVisible(field, form)
  if (!visible) return null
  const usesTaskApi = field?.key === NEXT_PROPOSED_TASK_KEY
  const itemConfig = getReviewFormItemConfig(field)

  return (
    <Form.Item name={field?.key} {...itemConfig}>
      <ReviewFormField
        field={field}
        form={form}
        taskOptions={usesTaskApi ? taskOptions : undefined}
        taskOptionsLoading={usesTaskApi ? taskOptionsLoading : false}
        disabled={disabled}
      />
    </Form.Item>
  )
}

function ReviewFormSection({ sectionKey, fields, form, taskOptions, taskOptionsLoading, isLeadAutoFlagCriteriaMet }) {
  return (
    <Group gap="8px" template="633px">
      <Legend title={getSectionTitle(sectionKey)} className="mbe-8" />
      {fields?.map(field => (
        <ReviewFormFieldRow
          key={field.key}
          field={field}
          form={form}
          disabled={field?.key === "flag_lead" ? isLeadAutoFlagCriteriaMet : false}
          taskOptions={taskOptions}
          taskOptionsLoading={taskOptionsLoading}
        />
      ))}
    </Group>
  )
}

export default function ReviewFormSections({ sections, form, callNextTaskAPI, isLeadAutoFlagCriteriaMet }) {
  const sectionKeys = Object.keys(sections ?? {})
  const { data: taskOptions, isFetching: taskOptionsLoading } = useGetNewTasksQuery(undefined, {
    skip: !callNextTaskAPI,
  })

  if (!sectionKeys.length) return null

  return (
    <>
      {sectionKeys.map(sectionKey => (
        <ReviewFormSection
          isLeadAutoFlagCriteriaMet={isLeadAutoFlagCriteriaMet}
          key={sectionKey}
          sectionKey={sectionKey}
          fields={sections[sectionKey]}
          form={form}
          taskOptions={taskOptions}
          taskOptionsLoading={taskOptionsLoading}
        />
      ))}
    </>
  )
}
